import { EventEmitter } from 'events';

class Parameter extends EventEmitter {

	static defaults = {
		min: 0,
		max: 127,
		step: 1,
		default: 0,
		path: "PATH_NOT_SET",
		name: "",
		scale: "linear",
		internalScale: "linear",
		lock_step: false,
		places: 3
	};

	constructor(options) {
		super();
		options = Object.assign({}, Parameter.defaults, options);
		this.param = false;
		this.min = options.min;
		this.max = options.max;
		this.step = options.step;
		this.default = options.default;
		this.normalized = this.getNormalizeFromValue(this.default);
		this.value = this.default;
		this.path = options.path;
		this.name = options.name;
		this.scale = options.scale;
		this.lock_step = options.lock_step;
		this.places = options.places;
		this.internalScale = options.internalScale;
	}

	/**
	 * @param normalized - expecting a number between 0 and 127
	 */
	setNormalized(normalized) {
		this.normalized = Math.max(Math.min(normalized, 127), 0);
		this.value = this.getValueFromNormalized(this.normalized);
		this.normalized = this.getNormalizeFromValue(this.value);
		if(this.param) {
			this.updateParam();
		}
		this.emit('change', {
			value: this.value,
			normalized: this.normalized
		});
	}

	/**
	 * @param value - expecting a number between 'min' and 'max'
	 */
	setValue(value) {
		this.value = Math.max(Math.min(value, this.max), this.min);
		if(this.lock_step) {
			this.value = this.roundToStep(this.value);
		} else if(this.places) {
			this.value = this.round(this.value);
		}
		this.normalized = this.getNormalizeFromValue(this.value);
		if(this.param) {
			this.updateParam();
		}
		this.emit('change', {
			value: this.value,
			normalized: this.normalized
		});
	}

	getValueFromNormalized(normalized) {
		normalized = (normalized / 127);
		var value = 0;
		switch (this.scale) {
			case "log2":
				value = this.max * Math.pow(2, Math.log2(this.max / this.min) * (normalized - 1.0));
				break;
			case "square":
				value = this.min + Math.pow(Math.pow(normalized,2) * Math.pow(this.max - this.min, 2), 1/2);
				break;
			case "10log10":
				value = Math.max(Math.log(normalized * Math.pow(10, this.max/10))*Math.LOG10E*10, this.min);
				break;
			case "linear":
			default:
				value = this.min + (normalized * (this.max - this.min));
				break;
		}

		if(this.lock_step) {
			value = this.roundToStep(value);
		} else if(this.places) {
			value = this.round(value);
		}

		return value;
	}

	roundToStep(value) {
		return Math.round(value/this.step)*this.step;
	}

	round(value) {
		var rounder = (1 << this.places).toString(2)*1;
		return Math.round(value*rounder)/rounder;
	}

	getNormalizeFromValue(value) {
		switch (this.scale) {
			case "log2":
				return ((Math.log(value/this.max) / Math.LN2) / Math.log2(this.max / this.min) + 1) * 127;
				break;
			case "square":
				return Math.pow(Math.pow(value - this.min, 2) / (Math.pow(this.max - this.min, 2)), 1/2) * 127;
				break;
			case "10log10":
				return (Math.pow(10, (value)/10) / Math.pow(10, this.max/10)) * 127;
				break;
			case "linear":
			default:
				return ((value - this.min) / (this.max - this.min)) * 127;
				break;
		}
	}

	setParam(param) {
		this.param = param;
		this.updateParam();
		this.emit('change', {
			value: this.value,
			normalized: this.normalized
		});
	}

	updateParam() {
		var value = this.value;
		if(this.internalScale == "10log10") {
			value = Math.pow(10, value/10);
		}
		this.param.setValueAtTime(value, 0);
	}

}

export default Parameter;
